import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const headerStyle = {
    width: "100%",
    height: "50px",
    backgroundColor: "orange",
    boxShadow: "0 0 10px rgba(0,0,0,.3)",
    textAlign: "center",
    color: "#EEEEEE"
  };

  const titleStyle = {
    fontWeight: "bold",
    fontSize: "1.5rem",
    lineHeight: "1.3",
    paddingTop: "7px"
  };

  const linkStyle = {
    textDecoration: "none",
    color: "white"
  };

  return (
    <div style={headerStyle}>
      <p style={titleStyle}>
        <Link to="/" style={linkStyle}>
          Typing
        </Link>
      </p>
    </div>
  );
};

export default Header;
